<template>
  <Teleport to="body">
    <Transition name="modal-fade">
      <div v-if="visible" class="modal-overlay">
        <Transition name="modal-scale">
          <div class="modal-content">
            <div class="modal-header">
              <div class="modal-title">{{ $t("message.use_usdt_payment") }}</div>
              <div class="close-btn" @click="handleClose">×</div>
            </div>

            <!-- <button class="connect-btn" @click="connectWallet" v-if="selectedNetwork == 'ton'">
              <div v-if="!isConnected" class="connect-btn-context">
                <img src="@/assets/icon/wallet-black.svg" />
                {{ $t("message.connect_wallet") }}
              </div>
              <div v-else>{{ $t("message.start_transaction") }}</div>
            </button> -->

            <!-- <div class="header-line">
            </div> -->

            <div class="manual-transfer">
              <div class="transfer-item">
                <div class="label label-row">
                  <div>{{ $t("message.address") }}:</div>
                  <img src="@/assets/icon/qr-code.svg" class="qr-icon" @click="toggleQRCode" />
                </div>
                <div class="content-row">
                  <div class="value">{{ orderDetail.ton_address }}</div>
                  <div class="copy-btn" @click="copyToClipboard(orderDetail.ton_address)">
                    {{ $t("message.copy") }}
                  </div>
                </div>
              </div>

              <div class="transfer-item" v-if="selectedNetwork == 'ton'">
                <div class="label label-row">
                  <div>{{ $t("message.comment_memo") }}:</div>
                  <img src="@/assets/icon/qr-code.svg" class="qr-icon" @click="toggleMemoQRCode" />
                </div>
                <div class="content-row">
                  <div class="value">{{ orderDetail.order_id }}</div>
                  <div class="copy-btn" @click="copyToClipboard(orderDetail.order_id)">
                    {{ $t("message.copy") }}
                  </div>
                </div>
              </div>

              <div class="transfer-item">
                <div class="label">{{ $t("message.amount") }}:</div>
                <div class="content-row">
                  <div class="value">{{ orderDetail.amount_ton }} USDT</div>
                  <div class="copy-btn" @click="copyToClipboard(orderDetail.amount_ton)">
                    {{ $t("message.copy") }}
                  </div>
                </div>
              </div>

              <div class="transfer-item">
                <div class="label">{{ $t("message.chain_type") }}:</div>
                <div class="content-row">
                  <div class="value network-type">
                    <img :src="networkInfo[params.chain_type].icon" class="network-icon" />
                    <span>{{ networkInfo[params.chain_type].name }}</span>
                  </div>
                  <div class="copy-btn" style="color: transparent;pointer-events:none">
                    {{ $t("message.copy") }}
                  </div>
                </div>
              </div>


              <div v-if="showQRCode" class="qr-modal">
                <div class="qr-container">
                  <div class="qr-header">
                    <div class="qr-title">{{ $t("message.wallet_address") }}</div>
                    <div class="close-btn" @click="toggleQRCode">×</div>
                  </div>
                  <VueQrcode :value="orderDetail.ton_address" :options="{
                    width: 220,
                    margin: 0,
                    color: {
                      dark: '#000000',
                      light: '#FFFFFF',
                    },
                  }" />
                </div>
              </div>

              <div v-if="showMemoQRCode" class="qr-modal">
                <div class="qr-container">
                  <div class="qr-header">
                    <div class="qr-title">{{ $t("message.comment_memo") }}</div>
                    <div class="close-btn" @click="toggleMemoQRCode">×</div>
                  </div>
                  <VueQrcode :value="orderDetail.order_id" :options="{
                    width: 220,
                    margin: 0,
                    color: {
                      dark: '#000000',
                      light: '#FFFFFF',
                    },
                  }" />
                </div>
              </div>
            </div>

            <div class="payment-tips">
              <button class="check-transaction-btn" @click="checkTransactionStatus" :disabled="isChecking">
                <template v-if="isChecking">
                  <div class="loading-spinner-small"></div>
                  {{ $t("message.checking") }}
                </template>
                <template v-else>
                  {{ $t("message.check_transaction_status") }}
                </template>
              </button>
              <div class="tips-content">
                <!-- p>
                  <span class="number">1</span>
                  {{ selectedNetwork == 'ton' ?
                    $t("message.you_can_choose_to_connect_wallet_to_pay") :
                    $t("message.or_manually_transfer_to_the_above_address_usdt")
                  }}
                </p>
                <p v-if="selectedNetwork == 'ton'">
                  <span class="number">2</span>
                  {{ $t("message.or_manually_transfer_to_the_above_address") }}
                </p -->
                <p v-if="selectedNetwork == 'ton'">
                  <span class="number">1</span>
                  {{ $t("message.twa_pay_tip_with_memo") }}
                </p>
                <p v-if="selectedNetwork == 'tron'">
                  <span class="number">1</span>
                  {{ $t("message.twa_pay_tip") }}
                </p>
              </div>
            </div>

            <!-- 交易状态提示 -->
            <Transition name="fade">
              <div v-if="transactionStatus" class="transaction-status-overlay">
                <div class="transaction-status-content">
                  <div v-if="isLoading" class="loading-spinner"></div>
                  <span>{{ transactionStatus }}</span>
                </div>
              </div>
            </Transition>
          </div>
        </Transition>
      </div>
    </Transition>
  </Teleport>
</template>

<script setup>
import { ref, onMounted, onUnmounted, computed, inject, watch } from "vue";
import emitter from "../utils/bus";
import VueQrcode from "@chenfengyuan/vue-qrcode";
import { useTonConnectStore } from "../store/tonConnect";
import {
  appHapticFeedback,
  appHapticFeedbackSoft,
  toastSuccess,
  toastFail,
} from "../utils/common";
import { useUserStore } from "../store/user";
import { useI18n } from "vue-i18n";
import { useConfigStore } from "../store/config";
import tron from "@/assets/networks/tron.svg";
import ton from "@/assets/networks/ton.svg";
import { checkOrderV4 } from "@/api/TON";

const $swal = inject("$swal");
const { t } = useI18n();
const visible = ref(false);
const config = useConfigStore();
const orderDetail = ref({
  ton_address: "0x0000000000000000000000000000000000000000",
  order_id: "0000000000000000000000000000000000000000",
  amount_ton: "0",
});
const tonConnectStore = useTonConnectStore();
const isMode = ref(false);
const showQRCode = ref(false);
const isLoading = ref(false);
const transactionStatus = ref("");
const showMemoQRCode = ref(false);
const selectedNetwork = ref(""); // 选择的网络
// 判断是否连接钱包
const isConnected = computed(() => tonConnectStore.isLinked);
const params = ref({});
const isChecking = ref(false);

const networkInfo = {
  tron: {
    name: "TRON Chain - TRC20",
    icon: tron
  },
  ton: {
    name: "TON Chain",
    icon: ton
  }
};

const handleClose = (isOpenPricing = true) => {
  visible.value = false;
  if (isMode.value && isOpenPricing) {
    emitter.emit("showPricing", true);
  }
};

const showTonPayment = (payAmount) => {
  orderDetail.value = payAmount.data.data;
  isMode.value = payAmount.isMode;
  selectedNetwork.value = payAmount.selectedNetwork;
  params.value = payAmount.params;
  visible.value = true;
};

const copyToClipboard = async (text) => {
  appHapticFeedback();
  try {
    await navigator.clipboard.writeText(text);
    toastSuccess($swal, t("message.copySuccess"));
  } catch (error) {
    toastFail($swal, t("message.copyFailure"));
  }
};

const toggleQRCode = () => {
  appHapticFeedbackSoft();
  showQRCode.value = !showQRCode.value;
};

const toggleMemoQRCode = () => {
  appHapticFeedbackSoft();
  showMemoQRCode.value = !showMemoQRCode.value;
};

const connectWallet = async () => {
  appHapticFeedback();

  isLoading.value = true;
  transactionStatus.value = t("message.Loading");

  try {
    const res = await tonConnectStore.startUsdtTransaction(
      orderDetail.value.amount_ton,
      orderDetail.value
    );
    if (res == "linkedWallet") {
      setTimeout(() => {
        transactionStatus.value = "";
        isLoading.value = false;
      }, 2000);
      return;
    }
    if (res) {
      transactionStatus.value = t("message.transaction_success");
      setTimeout(async () => {
        transactionStatus.value = "";
        isLoading.value = false;
        // 支付成功操作
        emitter.emit("updateMinerData", ""); // 刷新矿机
        handleClose(false);
        emitter.emit("closePayment", false);
      }, 1500);
    } else {
      transactionStatus.value = t("message.transaction_failed");
      setTimeout(() => {
        transactionStatus.value = "";
        isLoading.value = false;
      }, 2000);
    }
  } catch (error) {
    console.log(error);

    transactionStatus.value = t("message.transaction_error");
    setTimeout(() => {
      transactionStatus.value = "";
      isLoading.value = false;
    }, 2000);
  } finally {
    isLoading.value = false;
  }
};

const checkTransactionStatus = async () => {
  appHapticFeedback();
  isLoading.value = true;
  transactionStatus.value = t("message.Loading");

  let res = await checkOrderV4({
    order_id: orderDetail.value.order_id,
    chain_type: selectedNetwork.value
  })
  
  isLoading.value = false;
  if (res.data == "success") {
    transactionStatus.value = t("message.transaction_success");
    window.location.reload();
  } else {
    transactionStatus.value = t("message.transaction_wait");
  }

  setTimeout(() => {
    transactionStatus.value = "";
  }, 2000);
};

onMounted(() => {
  emitter.on("showOtherTonPayment", showTonPayment);
});

onUnmounted(() => {
  emitter.off("showOtherTonPayment", showTonPayment);
});
watch(
  () => config.themes_color,
  (newColor) => {
    document.documentElement.style.setProperty("--theme-color", newColor);
  }
);
</script>

<style scoped>
:root {
  --theme-color: #00ff9d;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  font-family: Arial, sans-serif;
}

.modal-content {
  background-color: #ffffff;
  border-radius: 4vw;
  width: 92vw;
  max-width: 600px;
  position: relative;
  box-shadow: 0 0.6vw 3vw rgba(0, 0, 0, 0.1);
}

.modal-header {
  padding: 4vw;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 0.3vw solid #e5e5e5;
}

.modal-title {
  font-size: 5.5vw;
  color: #333333;
  font-weight: bold;
}

.close-btn {
  font-size: 7vw;
  color: #999999;
  cursor: pointer;
  transition: all 0.3s ease;
}

.close-btn:hover {
  color: #333333;
}

.connect-btn {
  width: calc(100% - 8vw);
  margin: 4vw;
  background-color: var(--theme-color);
  border: none;
  color: #fff;
  font-size: 4.5vw;
  font-weight: bold;
  padding: 4vw;
  border-radius: 2vw;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  justify-content: center;
  align-items: center;
}

.connect-btn:hover {
  opacity: 0.9;
  transform: translateY(-0.2vw);
}

.connect-btn-context {
  display: flex;
  align-items: center;
  gap: 3vw;
}

.connect-btn-context img {
  width: 5vw;
  height: 5vw;
}

.manual-transfer {
  padding: 4vw;
  background-color: #f5f5f5;
  margin: 4vw;
  border-radius: 3vw;
}

.transfer-item {
  margin-bottom: 4vw;
}

.transfer-item:last-child {
  margin-bottom: 0;
}

.label-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.label {
  font-size: 4vw;
  color: #666666;
  margin-bottom: 2vw;
}

.qr-icon {
  width: 5vw;
  height: 5vw;
  cursor: pointer;
  transition: opacity 0.3s ease;
}

.qr-icon:hover {
  opacity: 0.8;
}

.content-row {
  display: flex;
  align-items: center;
  gap: 3vw;
  background-color: #ffffff;
  padding: 3vw;
  border-radius: 2vw;
  border: 0.3vw solid #e5e5e5;
}

.value {
  flex: 1;
  font-size: 4vw;
  color: #333333;
  word-break: break-all;
}

.copy-btn {
  font-size: 3.5vw;
  color: var(--theme-color);
  cursor: pointer;
  padding: 1.5vw 3vw;
  border-radius: 1.5vw;
  transition: all 0.3s ease;
  white-space: nowrap;
}

.copy-btn:hover {
  background-color: rgba(0, 255, 157, 0.1);
}

.payment-tips {
  padding: 4vw;
  padding-top: 0;
}

.check-transaction-btn {
  width: 100%;
  margin-bottom: 4vw;
  background-color: var(--theme-color);
  border: none;
  color: #fff;
  font-size: 4vw;
  font-weight: bold;
  padding: 3vw;
  border-radius: 2vw;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 2vw;
}

.check-transaction-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.tips-content {
  font-size: 3.5vw;
  color: #666666;
  line-height: 1.6;
}

.number {
  display: inline-block;
  width: 5vw;
  height: 5vw;
  background-color: #f5f5f5;
  color: #333333;
  text-align: center;
  line-height: 5vw;
  border-radius: 50%;
  margin-right: 2vw;
  border: 0.3vw solid #e5e5e5;
}

.qr-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.95);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1001;
}

.qr-container {
  background-color: #ffffff;
  padding: 5vw;
  border-radius: 3vw;
  text-align: center;
}

.qr-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4vw;
}

.qr-title {
  font-size: 5vw;
  color: #000000;
  font-weight: bold;
}

.transaction-status-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.95);
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 3vw;
  z-index: 1;
}

.transaction-status-content {
  text-align: center;
  color: #333333;
  font-size: 4vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3vw;
}

.loading-spinner {
  width: 10vw;
  height: 10vw;
  border: 0.8vw solid #e5e5e5;
  border-top-color: var(--theme-color);
  border-radius: 50%;
  animation: spin 1s infinite linear;
  margin: 0 auto 3vw;
}

.loading-spinner-small {
  width: 4vw;
  height: 4vw;
  border: 0.4vw solid rgba(255, 255, 255, 0.3);
  border-top-color: #fff;
  border-radius: 50%;
  animation: spin 1s infinite linear;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

/* 动画 */
.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.3s ease;
}

.modal-fade-enter-from,
.modal-fade-leave-to {
  opacity: 0;
}

.modal-scale-enter-active,
.modal-scale-leave-active {
  transition: all 0.3s ease;
}

.modal-scale-enter-from,
.modal-scale-leave-to {
  transform: scale(0.9);
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.network-type {
  display: flex;
  align-items: center;
  gap: 2vw;
}

.network-icon {
  width: 5vw;
  height: 5vw;
  object-fit: contain;
}
</style>
